type AppConfig = {
  apiUser: string;
  apiKey: string;
  apiBaseUrl: string;
};

const config: AppConfig = {
  apiUser: "noot",
  apiKey: "WlTIDmee2lK0Z0EAIeBexOr0AKvXd1qF",
  apiBaseUrl: "https://retroachievements.org/API/",
};

export { config };
